import actionCreators from './actionCreators';

import liveUpdatesAPI from 'media-base-ui/utils/liveUpdatesAPI';

const fetchLiveUpdate = (args) => async dispatch => {
    dispatch(actionCreators.requestLiveUpdate());
    try {
        let response = await liveUpdatesAPI.fetchLiveUpdates(args);
        if (response.data.length === 0 && !args.searchDate) {
            response = await liveUpdatesAPI.fetchLastLiveUpdate(args);
        }
        dispatch(actionCreators.liveUpdateResponse(true, [], response.data));
    }
    catch (errors) {
        dispatch(actionCreators.liveUpdateResponse(false, errors, []));
    }
};

export default {
	fetchLiveUpdate,
}